<template>

    <tr class="text-left"
        :class="[{'declined-row' : postulationStatus === 'declined'},'p-5']">
        <!-- PopUpPreview -->
        <b-popover :target="'target-'+data.status +'-'+data.candidate.id"
                   triggers="hover focus"
                   placement="left"
                   :key="'key-'+data.status +'-'+data.candidate.id">
            <template v-slot:title>
                <b-img height="40"
                       width="40"
                       rounded="circle"
                       alt="ProfileUser"
                       :src="creatorImage"
                       @error="imgError = true">
                </b-img>
                <span class="text-color-kllaar h4">
                     {{ data.candidate.name }} {{ data.candidate.lname ? data.candidate.lname : '' }}
                </span>
            </template>
            <div class="row">

                <div class="col-lg-12">
                    <CurriculumPreview :user="data.candidate_info" :isGold="isGold"/>
                </div>
            </div>
        </b-popover>
        <!-- /PopUpPreview -->

        <b-popover :target="'btn-not-gold'+ data.candidate.id" triggers="hover focus" placement="left"
                   :key="data.candidate.id">
            <div class="row">
                <div class="col-lg-12 text-center mt-3">
                    <h3 class="font-yellow font-weight-bold">
                        <h3 class="fas fa-medal font-yellow p-1"></h3>
                        Match
                    </h3>
                    <p>
                        Obtén el porcentaje de compatibilidad del candidato con tu vacante.
                    </p>
                    <div class="mt-4 mb-4">
                        <b-button @click="$router.push('/memberships')"
                                  class="b-orange px-3 font-weight-bold">
                            Solo con membresía ORO
                        </b-button>
                    </div>
                </div>
            </div>
        </b-popover>

        <!--ModalDecline-->
        <b-modal centered size="md" title="Bienvenido a Kllaar" hide-footer hide-header v-model="modal_declined">
            <b-form @submit="declineCandidate">
                <div class="target text-center">
                    <img src="@/assets/w_logo_max_b.png" alt="" height="50">
                    <hr>
                    <div class="_option p-2">
                        <h4 class="font-blue">{{ data.candidate.name }}
                            {{ data.candidate.lname ? data.candidate.lname : '' }}</h4>
                        <div class="mb-3">
                            Vemos que has descartado a este candidato <br>
                            Por favor, compártenos cual es el motivo
                        </div>
                        <b-form-select
                                v-model="form.motivo_declined"
                                :options="motivos"
                                required></b-form-select>
                    </div>
                    <small>*Esta información es confidencial, sólo se emplea para cuestiones de estadistica.</small>
                    <div class="_buttons mt-4">
                        <b-button type="submit" class="b-orange px-3 font-weight-bold" :disabled="loading.declined">
                            <b-spinner v-if="loading.declined" small label="Espere ..."></b-spinner>
                            Guardar
                        </b-button>
                        <button type="button" class="btn b-gray-lights px-3 font-weight-bold"
                                @click="modal_declined = false">
                            Cancelar
                        </button>
                    </div>
                </div>
            </b-form>
        </b-modal>
        <!--./ModalDecline-->


        <!-- TableData -->
        <td class="text-center align-middle">

            <div v-if="isGold" class="font-weight-bold mt-2">
                <div v-if="data.match.percentage > 0">
                    <h5 class="font-weight-bold">
                        <h5 class="fas fa-star font-yellow"></h5>
                        {{ data.match.percentage }}% <br>
                        <small>Compatible</small>
                    </h5>
                </div>
                <div v-else>
                    <h5 class="font-gray-light">
                        <h5 class="fas fa-star font-gray-light"></h5> 0%<br>
                        <small>Compatible</small>
                    </h5>
                </div>
            </div>
            <div v-else>
                <h4 :id="'btn-not-gold' + data.candidate.id"
                    class="fas fa-info-circle font-yellow p-1 rounded mt-2">
                </h4>
            </div>

        </td>
        <td class="align-middle"
            :id="postulationStatus !== 'declined' ? 'target-'+data.status +'-'+data.candidate.id : data.id ">

            <div class="d-inline">
                <b-img height="40"
                       width="40"
                       rounded="circle"
                       alt="ProfileUser"
                       :src="creatorImage"
                class="float-left mr-2">
                </b-img>

                <a href="" @click="showCandidate" class="text-dark">
                    <div class="d-block">
                        <span>
                            {{ data.candidate.name }}
                        </span><br>
                        <span>
                        {{ data.candidate.lname ? data.candidate.lname : ''}}
                        </span>
                    </div>
                </a>
            </div>

        </td>
        <td class="text-center pt-3">

            <div v-if="data.contacted_add.valid"> <!--Candidato adquirido -->

                <div v-if="data.is_conversation.valid"> <!-- Conversación iniciada -->

                    <b-button size="sm"
                              class="b-green shadow-sm"
                              @click="showConversation">
                        <i class="fas fa-check font-green b-white rounded-circle"></i>
                        Ver conversación
                    </b-button>

                </div>

                <div v-else> <!--Sin Conversación -->
                    <b-button size="sm" class="b-blue shadow-sm" :disabled="loading.conversation"
                              @click="sendConversation">
                        <i class="fas fa-check font-blue b-white rounded-circle" v-show="!loading.conversation"></i>
                        <b-spinner v-show="loading.conversation" small label="Espere ..."></b-spinner>
                        Enviar petición
                    </b-button>
                </div>

            </div>

            <div v-else> <!--Candidato no adquirido -->
                <i class="fas fa-window-close font-red p-1"></i>
                No adquirido
            </div>

        </td>
        <td class="text-center pt-3"> 
             <!--ModalDecline-->
            <b-modal centered size="md" title="Candidato" hide-footer hide-header v-model="modal_dat"> 
                    <div class="target text-center">
                        <b-list-group>
                            <b-list-group-item button @click="showCandidate">Ver perfil y Adquirir candidato</b-list-group-item>
                            <b-list-group-item button @click="onAccept('read')"><i class="fas fa-clipboard font-kllaar"></i> Evaluado</b-list-group-item>
                            <b-list-group-item button @click="onAccept('interviewed')"><i class="fas fa-question-circle font-kllaar"></i> Entrevistado</b-list-group-item>
                            <b-list-group-item button @click="onAccept('negotiation')"><i class="fas fa-hand-holding-usd font-kllaar"></i> Propuesta</b-list-group-item>
                            <b-list-group-item button @click="onAccept('aproved')"><i class="fas fa-check font-green"></i> Candidato Contratado</b-list-group-item>
                            <b-list-group-item button @click="modal_declined = true"><i class="fas fa-times font-red"></i> Rechazar candidato</b-list-group-item>
                        </b-list-group>         
                        <div class="_buttons mt-4"> 
                            <button type="button" class="btn b-gray-lights px-3 font-weight-bold"
                                    @click="modal_dat = false">
                                Cancelar
                            </button>
                        </div>
                    </div> 
            </b-modal>
            <template v-if="isMobile">
                <b-button type="button" class="font-white shadow bg-primary mt-3" @click="modal_dat = true"> 
                    Candidato <b-spinner small label="Espere ..." v-show="loader"></b-spinner>
                </b-button> 
            </template>
            <b-dropdown id="dropdown-1" text="Candidato" class="m-0" size="sm"  v-if="postulationStatus !== 'declined' && !isMobile" style="z-index:3;" > 
                    <b-dropdown-item @click="showCandidate">
                        Ver perfil y Adquirir candidato
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>

                    <b-dropdown-item @click="onAccept('read')">
                        <i class="fas fa-clipboard font-kllaar"></i>
                        Evaluado
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>

                    <b-dropdown-item @click="onAccept('interviewed')">
                        <i class="fas fa-question-circle font-kllaar"></i>
                        Entrevistado
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>

                    <b-dropdown-item @click="onAccept('negotiation')">
                        <i class="fas fa-hand-holding-usd font-kllaar"></i>
                        Propuesta
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>

                    <b-dropdown-item @click="onAccept('aproved')">
                        <i class="fas fa-check font-green"></i>
                        Candidato Contratado
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>

                    <b-dropdown-item @click="modal_declined = true">
                        <i class="fas fa-times font-red"></i> Rechazar candidato
                    </b-dropdown-item>  
            </b-dropdown> 
            <b-spinner small label="Espere ..." v-show="loader == true"></b-spinner>
        </td>

        <!-- /TableData -->
    </tr>


</template>
<style lang="scss"> 

#dropdown-1{
  z-index: 3;
}

#global {
	height: 320px;
	width: 100%;
	border: 1px solid #ddd;
	background: #f1f1f1;
	overflow-y: scroll;
}
#mensajes {
	height: auto;
}
.popover {
  min-width: 20%;
  max-width: 100%;
}

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #244076;
  border-color: #244076;
}

.btn-secondary.disabled {
  color: #ffffff;
}

.declined-row {
  opacity: .2;
}
</style>
<script>
export default {
    props: {
        data: Object,
        isGold: Boolean,
        jobId: String
    },
    data() {
        return {
            isMobile: this.$mobile(),
            postulationStatus: this.data.status,
            defaultImage: require('@/assets/profile/user_empty.png'),

            //:: Decline ::
            modal_declined: false,
            modal_dat:false,
            motivos: [
                {text: 'Selecciona una opción', value: null},
                'No cumple con las habilidades que se requiren para el puesto',
                'Necesita trabajar en su CV',
                'Falta experiencia para el puesto',
                'No cumple con la carrera requerida para el puesto',
                'No cuenta con logros académicos',
                'Su pitch / presentación no es suficientemente atractivo o convincente'
            ],
            loading: {
                declined: false,
                message: false,
                preview: false,
                conversation: false,
            },
            form: {
                candidate_id: this.data.candidate.id,
                job_id: this.jobId,
                status: '',
                motivo_declined: '',
            },
            loader:false
        }
    },
    computed: {
        creatorImage() {
            return this.data.candidate.avatar ? this.data.candidate.avatar : this.defaultImage
        },
    },
    methods: {
        showCandidate() {
            let user_id = this.data.candidate.id
            let routeData = this.$router.resolve({path: '/candidate?profile=' + user_id})
            window.open(routeData.href, '_blank')
        },
        onAccept(status) {
            this.loader =  true
            this.aproved = true
            this.status = status
            this.api.get('candidate/aceptedOnJob?job_id=' + this.jobId
                + '&candidate_id=' + this.data.candidate_info.id
                + '&status=' + status).then(({data}) => {
                this.postulationStatus = status
                this.loader = false
                this.$bus.$emit("change_candidate_status")
            }).catch(err => {
                this.aproved = false
                this.loader = false
            })
        },
        declineCandidate(e) {
            e.preventDefault()

            if (this.form.motivo_declined === '' && this.form.motivo_declined === null) {
                return false;
            }


            this.form.status = 'declined'
            this.loading.declined = true

            this.status = 'declined'
            this.api.post('enterprise/job/candidate/feedback', JSON.stringify(this.form)).then(({data}) => {
                this.postulationStatus = 'declined'
                this.loading.declined = false
                this.modal_declined = false
            }).catch(err => {
                this.loading.declined = false
            })
        },
        showConversation() {
            this.$router.push('/perfil/mensajes/' + this.data.is_conversation.conversation_url)
        },
        sendConversation() {
            let form = {
                job_id: this.jobId,
                user_to: this.data.candidate.id,
                title: 'Postulación de empleo'
            }

            this.loading.conversation = true
            this.api.post('conversation/store', JSON.stringify(form)).then(
                data => {
                    this.$router.push('/perfil/mensajes/' + data.data.conversation.conversation_url)
                    this.loading.conversation = false
                },
                error => {
                    this.loading.conversation = false
                }
            )
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/jobs/pages/components/CandidateRow.vue